import { currentCalendarPrice, } from '@honeycomb/data';
import { DateTime } from 'luxon';
import { getDayDiff, toUTCDate } from '../../utils/date-utils';
import { HotelDetailsActionType } from '../hotel';
export const ISODATEFORMAT = `yyyy-MM-dd'T00:00:00'`;
/**
 *
 * @param startDate Baseline date for obtaining the top three nearest cheapest days
 * @param calendarPrices The price of every day in a month
 * @returns Array of dates
 */
export function getDealDates(startDate, calendarPrices) {
    var _a;
    const filteredPrices = calendarPrices === null || calendarPrices === void 0 ? void 0 : calendarPrices.filter((p) => { var _a; return ((_a = p.price) !== null && _a !== void 0 ? _a : 0) > 0; });
    const minDealPrice = (filteredPrices === null || filteredPrices === void 0 ? void 0 : filteredPrices.length)
        ? filteredPrices.reduce((acc, loc) => { var _a, _b; return (((_a = acc === null || acc === void 0 ? void 0 : acc.price) !== null && _a !== void 0 ? _a : 0) < ((_b = loc === null || loc === void 0 ? void 0 : loc.price) !== null && _b !== void 0 ? _b : 0) ? acc : loc); })
        : undefined;
    const calendarMonthDealPrice = calendarPrices === null || calendarPrices === void 0 ? void 0 : calendarPrices.filter((dayData) => (dayData === null || dayData === void 0 ? void 0 : dayData.price) === (minDealPrice === null || minDealPrice === void 0 ? void 0 : minDealPrice.price));
    const dayDifferenceArray = calendarMonthDealPrice === null || calendarMonthDealPrice === void 0 ? void 0 : calendarMonthDealPrice.map((dateOfDay) => {
        return {
            dayDiff: Math.abs(getDayDiff(dateOfDay.date, startDate.toISOString())),
            monthDate: dateOfDay.date,
        };
    });
    const sortedResult = (_a = dayDifferenceArray === null || dayDifferenceArray === void 0 ? void 0 : dayDifferenceArray.sort((a, b) => a.dayDiff - b.dayDiff)) !== null && _a !== void 0 ? _a : [];
    const dayDiffObj = sortedResult.reduce((acc, item) => {
        const clone = Object.assign({}, acc);
        clone[item.dayDiff] = clone[item.dayDiff] ? clone[item.dayDiff] + 1 : 1;
        return clone;
    }, {});
    let totalCount = 0;
    const dayDiffArr = [];
    Object.entries(dayDiffObj).forEach(([key, count]) => {
        if (totalCount >= 3) {
            return;
        }
        dayDiffArr.push(key);
        totalCount += count;
    });
    const dates = dayDifferenceArray === null || dayDifferenceArray === void 0 ? void 0 : dayDifferenceArray.filter((d) => dayDiffArr.includes(String(d.dayDiff))).map((d) => String(d.monthDate));
    return dates;
}
export const getDestinations = (hotel, destinations) => {
    const { isCached, estabId, geography, name } = hotel;
    return (destinations || [
        {
            id: Number(estabId),
            isCached: Boolean(isCached),
            title: name,
            type: 1,
            subTitle: [geography === null || geography === void 0 ? void 0 : geography.location, geography === null || geography === void 0 ? void 0 : geography.province, geography === null || geography === void 0 ? void 0 : geography.country]
                .filter((attr) => (attr || '').trim())
                .join(', '),
        },
    ]);
};
export const calendarSideEffect = (data, detailsContextValue, visibilityThreshold) => {
    var _a, _b, _c, _d;
    const { state: { pricingCalendarInitialLoad, showPricingCalendar }, dispatch: detailsDispatch, } = detailsContextValue;
    if (!pricingCalendarInitialLoad) {
        const remainingDays = (_b = (_a = data.hotelTeaserPrices) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b.filter((tp) => DateTime.fromISO(tp.date).toMillis() >= DateTime.now().startOf('day').toMillis());
        const totalDays = (_c = remainingDays === null || remainingDays === void 0 ? void 0 : remainingDays.length) !== null && _c !== void 0 ? _c : 0;
        const priceAvailableDays = (_d = remainingDays === null || remainingDays === void 0 ? void 0 : remainingDays.filter((tp) => tp.price).length) !== null && _d !== void 0 ? _d : 0;
        const priceFillPercentage = totalDays ? (priceAvailableDays / totalDays) * 100 : 0;
        if (showPricingCalendar && priceFillPercentage < visibilityThreshold) {
            detailsDispatch({
                type: HotelDetailsActionType.SET_PRICING_CALENDAR_TOGGLE,
                payload: false,
            });
        }
        detailsDispatch({
            type: HotelDetailsActionType.SET_PRICING_CALENDAR_INITIAL_LOAD,
            payload: true,
        });
    }
};
// This function is used to log metrics to datadog around price diffs vs the availability price
export function handleCurrentCalendarPrice(data, calendarStartDate, tripStateId, estabId) {
    var _a, _b;
    const utcDate = toUTCDate(new Date(calendarStartDate));
    if (!utcDate || !tripStateId)
        return;
    const highlightedDate = utcDate.split('T')[0];
    const prices = (_b = (_a = data.hotelTeaserPrices) === null || _a === void 0 ? void 0 : _a.prices) !== null && _b !== void 0 ? _b : [];
    const todaysPrice = prices.find((day) => day.date.split('T')[0] === highlightedDate);
    if (!(todaysPrice === null || todaysPrice === void 0 ? void 0 : todaysPrice.price))
        return;
    currentCalendarPrice({
        tripStateId,
        estabId,
        price: todaysPrice.price,
    });
}
